import { Injectable, signal } from '@angular/core'

@Injectable()
export class NavBarService {
  public activeTab = signal('')
}
